<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>Booth Events
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div>
        <div class="message-alert">
          <div
            class="alertM alert-dismissible animate__animated animate__fadeInRight animate__fast"
            :class="'alert-' + item.status"
            v-for="(item, i) in messages"
            :key="i"
          >
            <span class="mr-2">
              <i class="fas fa-bell"></i>
            </span>
            {{ item.message }}
          </div>
        </div>

        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">Account :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="PcDevice">
          <div class="contentBoxStatus">
            <Dashboard></Dashboard>
          </div>
          <div class="my-3"></div>
        </div>

        <div class="contentBox">
          <div id="SliderTop">
            <i class="fas fa-2x fa-chevron-up toTop-arrow"></i>
          </div>

          <div class="MbDevice">
            <Dashboard></Dashboard>
          </div>

          <div class="d-flex justify-content-between">
            <div>
              <h1>Booth Events</h1>
            </div>
          </div>

          <p class="my-3">&nbsp;</p>
          <p class="alert">
            You have published
            <span class="red" name="existProd">{{ totalNo }}</span>
            event(s), you can publish
            <span class="red" name="leftAmount">{{
              EventAmount - totalNo
            }}</span>
            more. Sort by last modified date.
          </p>
          <p class="my-3">&nbsp;</p>

          <div class="PcDevice_inline">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <div>
                <span
                  class="btn btn-lg btn-primary text-nowrap mr-2"
                  @click.prevent="toEventAdd"
                  >Add a New Event</span
                >

                <span
                  >Reached the limit? Please refer to our
                  <a :href="`upgrade?no=${RegNo}`" class=" "
                    >additional services information</a
                  >.</span
                >
              </div>
            </div>
          </div>

          <div class="MbDevice">
            <div class="d-flex align-items-center mb-2">
              <div
                class="btn btn-lg btn-primary text-nowrap mr-2"
                @click.prevent="toEventAdd"
              >
                Add a New Event
              </div>
              <div>
                Reached the limit? Please refer to our
                <a :href="`upgrade?no=${RegNo}`"
                  >additional services information</a
                >.
              </div>
            </div>
          </div>

          <div class="PcDevice">
            <p class="my-3">&nbsp;</p>

            <ul v-for="(item, index) in EventList" :key="item.BoothEventID">
              <li>
                <div
                  class="d-flex justify-content-between align-items-center mx-1"
                >
                  <div>
                    <div class="d-flex ml-3 align-items-center">
                      <div class="mt-4 d-flex align-items-center">
                        <span class="text-center pt-1 mr-3 NumberStyle">
                          {{ index + 1 }}
                        </span>
                        <img
                          :src="`${item.EventPic}`"
                          class="img-fluid"
                          width="200px"
                        />
                      </div>

                      <div class="ml-4">
                        <p
                          class="formTitle mb-2"
                          style="word-break: break-all; width: 500px"
                          v-if="item.BoothEventName !== 'N/A'"
                        >
                          {{ item.BoothEventName }}
                        </p>

                        <p
                          class="formTitle mb-2"
                          v-if="item.BoothEventName == 'N/A'"
                        >
                          <span class="text-danger">N/A (Not set)</span>
                        </p>

                        <div class="gray d-flex align-items-center">
                          <div>Display：</div>

                          <div
                            class="pointer d-flex align-items-center"
                            @click="
                              switchButtom(item.BoothEventID, item.IsShow)
                            "
                            v-if="!item.IsShow"
                          >
                            <div class="mt-1">
                              <img
                                src="@/assets/images/off-button.png"
                                width="28px"
                              />
                            </div>
                            <div class="ml-1">Hidden</div>
                          </div>

                          <div
                            class="pointer d-flex align-items-center"
                            @click="
                              switchButtom(item.BoothEventID, item.IsShow)
                            "
                            v-else
                          >
                            <img
                              src="@/assets/images/on-button.png"
                              width="28px"
                            />
                            <span class="ml-1">Shown</span>
                          </div>
                        </div>
                        <!-- <p class="gray" v-if="item.IsShow">
                          Website：

                          <i class="fas fa-eye mr-2"></i>
                          <a :href="item.PreViewUrl" target="_blank"
                            >Event preview</a
                          >
                        </p> -->
                        <p class="gray">Last updated：{{ item.UpdateTime }}</p>
                        <div class="gray" v-if="totalNo > 1">
                          Order：<span
                            style="color: #1a73e8"
                            class="pointer"
                            @click.prevent="openEventNo"
                            >Adjust</span
                          >
                        </div>
                        <div class="gray">
                          Event Time：
                          <div style="font-size: 14px">
                            <div
                              v-for="(time, index) in item.EventTime"
                              :key="index"
                            >
                              <span class="d-inline-block text-success">
                                <span>({{ index + 1 }})</span>
                                {{ formatEventDateTime(time.EventDateTime) }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="text-right mt-3">
                    <div class="PcDevice mr-5">
                      <div
                        class="btn btn-lg btn-primary text-nowrap"
                        @click.prevent="toEditEvent(item.BoothEventID)"
                      >
                        Edit
                      </div>

                      <div
                        class="btn btn-lg btn-secondary text-nowrap ml-2"
                        @click.prevent="delEvent(item.BoothEventID)"
                      >
                        Del
                      </div>
                    </div>
                    <div class="MbDevice">
                      <div
                        class="btn btn-sm btn-primary text-nowrap"
                        @click.prevent="toEditEvent(item.BoothEventID)"
                      >
                        Edit
                      </div>

                      <div
                        class="btn btn-sm btn-secondary text-nowrap ml-2"
                        @click.prevent="delEvent(item.BoothEventID)"
                      >
                        Del
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <hr />
            </ul>

            <!-- PC版分頁 -->

            <div
              v-if="totalPage > 1"
              class="pt-3 d-flex justify-content-center"
            >
              <nav>
                <ul class="pagination">
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == 0 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      title="切換前十頁"
                      aria-label="Previous"
                      @click="returntenPage()"
                    >
                      <span aria-hidden="true"
                        ><i class="fas fa-angle-double-left"></i
                      ></span>
                    </a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage == 1 }">
                    <a
                      class="page-link"
                      href="#"
                      title="上一頁"
                      aria-label="Previous"
                      @click="lastPage()"
                    >
                      <span aria-hidden="true">
                        <i class="fas fa-angle-left"></i>
                      </span>
                    </a>
                  </li>
                  <li
                    class="page-item"
                    v-for="page in showpage"
                    :key="page"
                    :class="{ active: currentPage == page }"
                  >
                    <a class="page-link" href="#" @click="getPage(page)">{{
                      page
                    }}</a>
                  </li>

                  <li
                    class="page-item"
                    :class="{ disabled: currentPage == totalPage }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      title="下一頁"
                      aria-label="Next"
                      @click="nextPage()"
                    >
                      <span aria-hidden="true"
                        ><i class="fas fa-angle-right"></i
                      ></span>
                    </a>
                  </li>
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      title="切換下十頁"
                      aria-label="Next"
                      @click="nexttenPage()"
                    >
                      <span aria-hidden="true"
                        ><i class="fas fa-angle-double-right"></i
                      ></span>
                    </a>
                  </li>
                </ul>
                <p class="text-center mt-2">
                  {{ currentPage }} / {{ totalPage }} pages
                </p>
              </nav>
            </div>
          </div>

          <!-- Mb版 -->

          <div class="MbDevice">
            <div class="col-lg-10 text-dark">
              <div class="row">
                <div
                  class="col-sm-6 mb-2"
                  v-for="(item, index) in EventList"
                  :key="item.BoothEventID"
                >
                  <div class="card mt-4">
                    <div class="card-body">
                      <div class="imgstyle text-center">
                        <div class="text-center">
                          <div class="ml-2 pt-1 NumberStyle mb-2">
                            {{ index + 1 }}
                          </div>
                        </div>
                        <img :src="`${item.EventPic}`" class="img-fluid" />
                      </div>
                      <ul class="list-group list-group-flush mx-2">
                        <div class="mt-3 mb-1" style="font-size: 15px">
                          <strong v-if="item.BoothEventName !== 'N/A'">{{
                            item.BoothEventName
                          }}</strong>
                        </div>

                        <div class="gray d-flex align-items-center">
                          <div>Display：</div>
                          <div
                            class="pointer d-flex align-items-center"
                            @click="
                              switchButtom(item.BoothEventID, item.IsShow)
                            "
                            v-if="!item.IsShow"
                          >
                            <div class="mt-1">
                              <img
                                src="@/assets/images/off-button.png"
                                width="28px"
                              />
                            </div>
                            <div class="ml-1">Hidden</div>
                          </div>

                          <div
                            class="pointer d-flex align-items-center"
                            @click="
                              switchButtom(item.BoothEventID, item.IsShow)
                            "
                            v-else
                          >
                            <img
                              src="@/assets/images/on-button.png"
                              width="28px"
                            />
                            <span class="ml-1">Shown</span>
                          </div>
                        </div>
                        <!-- <p class="gray" v-if="item.IsShow">
                          Website： <i class="fas fa-eye mr-1"></i>
                          <a :href="item.PreViewUrl" target="_blank"
                            >Event preview</a
                          >
                        </p> -->
                        <p class="gray">Last updated：{{ item.UpdateTime }}</p>
                        <div class="gray" v-if="totalNo > 1">
                          Order：<span
                            style="color: #1a73e8"
                            class="pointer"
                            @click.prevent="openEventNo"
                            >Adjust</span
                          >
                        </div>
                        <div class="gray mb-2">
                          Event Time：
                          <div style="font-size: 11px">
                            <div
                              v-for="(time, index) in item.EventTime"
                              :key="index"
                            >
                              <span class="d-inline-block text-success">
                                <span>({{ index + 1 }})</span>
                                {{ formatEventDateTime(time.EventDateTime) }}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <div
                            class="d-flex justify-content-between align-items-center mt-2"
                          >
                            <div>
                              Display :
                              <span
                                class="text-success text-nowrap"
                                v-if="item.IsShow"
                                >Shown</span
                              >
                              <span v-else class="text-danger text-nowrap"
                                >Hidden</span
                              >
                            </div>
                            <div>
                              <div
                                class="btn btn-sm btn-primary"
                                @click.prevent="toEditEvent(item.BoothEventID)"
                              >
                                Edit
                              </div>
                              <div
                                class="btn btn-sm btn-secondary btn-primary ml-1"
                                @click.prevent="delEvent(item.BoothEventID)"
                              >
                                Del
                              </div>
                            </div>
                          </div>
                        </div>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="totalPage > 1"
              class="pt-3 d-flex justify-content-center"
            >
              <nav>
                <ul class="pagination pagination-sm">
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == 0 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      title="切換前十頁"
                      aria-label="Previous"
                      @click="returntenPage()"
                    >
                      <span aria-hidden="true"
                        ><i class="fas fa-angle-double-left"></i
                      ></span>
                    </a>
                  </li>
                  <li class="page-item" :class="{ disabled: currentPage == 1 }">
                    <a
                      class="page-link"
                      href="#"
                      title="上一頁"
                      aria-label="Previous"
                      @click="lastPage()"
                    >
                      <span aria-hidden="true">
                        <i class="fas fa-angle-left"></i>
                      </span>
                    </a>
                  </li>
                  <li
                    class="page-item"
                    v-for="page in showpage"
                    :key="page"
                    :class="{ active: currentPage == page }"
                  >
                    <a class="page-link" href="#" @click="getPage(page)">{{
                      page
                    }}</a>
                  </li>

                  <li
                    class="page-item"
                    :class="{ disabled: currentPage == totalPage }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      title="下一頁"
                      aria-label="Next"
                      @click="nextPage()"
                    >
                      <span aria-hidden="true"
                        ><i class="fas fa-angle-right"></i
                      ></span>
                    </a>
                  </li>
                  <li
                    v-if="totaltenPageNum > 1"
                    class="page-item"
                    :class="{ disabled: tenPageNum == totaltenPageNum - 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      title="切換下十頁"
                      aria-label="Next"
                      @click="nexttenPage()"
                    >
                      <span aria-hidden="true"
                        ><i class="fas fa-angle-double-right"></i
                      ></span>
                    </a>
                  </li>
                </ul>
                <p class="text-center mt-2">
                  {{ currentPage }} / {{ totalPage }} pages
                </p>
              </nav>
            </div>
          </div>

          <!-- Modal -->
          <div
            class="modal fade"
            id="openModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="ModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <div class="PcDevice">
                    <div class="modal-title h3" id="ModalLabel">
                      <i class="fas fa-eye mr-1"></i> Event preview
                    </div>
                  </div>
                  <div class="MbDevice">
                    <div class="modal-title h5" id="ModalLabel">
                      <i class="fas fa-eye mr-1"></i> Event preview
                    </div>
                  </div>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <nav>
                    <div
                      class="nav mt-5 mx-3 nav-tabs"
                      id="nav-tab"
                      role="tablist"
                    >
                      <a
                        class="nav-item nav-link active"
                        id="nav-profile-tab"
                        data-toggle="tab"
                        href="#nav-profile"
                        role="tab"
                        aria-controls="nav-profile"
                        aria-selected="false"
                        >English</a
                      >

                      <a
                        class="nav-item nav-link"
                        id="nav-home-tab"
                        data-toggle="tab"
                        href="#nav-home"
                        role="tab"
                        aria-controls="nav-home"
                        aria-selected="true"
                        >中文版</a
                      >
                    </div>
                  </nav>
                  <div class="tab-content mx-2" id="pills-tabContent">
                    <div
                      class="tab-pane fade"
                      id="nav-home"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      <div class="row mt-5 justify-content-around">
                        <div class="col-4">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${ProductData.ProImg}`"
                            class="img-fluid"
                            width="320px"
                          />
                        </div>
                        <div class="col-7">
                          <div class="title-text-style mb-4">
                            <div>{{ ProductData.ProName }}</div>
                          </div>
                          <p>活動型號 : {{ ProductData.ProModel }}</p>
                          <p>廠商名稱 : {{ companyName }}</p>
                          <p>攤位號碼 : {{ BoothNo }}</p>
                          <hr />
                          <div class="my-3">
                            <p class="category-text-style my-3">活動特色</p>
                            <p
                              class="mb-5"
                              style="word-break: break-all"
                              v-html="ProductData.htmlProDesc"
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="tab-pane fade show active"
                      id="nav-profile"
                      role="tabpanel"
                      aria-labelledby="pills-home-tab"
                    >
                      <div class="row mt-5 justify-content-around">
                        <div class="col-4">
                          <img
                            :src="`//www.chanchao.com.tw/exhibitorServicefiles/products/${ProductData.ProImg}`"
                            class="img-fluid"
                            width="320px"
                          />
                        </div>
                        <div class="col-7">
                          <div class="title-text-style mb-4">
                            <div>{{ ProductData.eProName }}</div>
                          </div>
                          <p>Model : {{ ProductData.ProModel }}</p>
                          <p>Category : {{ SelectCat.MainCategoryNameEn }}</p>
                          <p>Exhibitor : {{ ecompanyName }}</p>
                          <p>Booth No. : {{ BoothNo }}</p>
                          <hr />
                          <div class="my-3">
                            <p class="category-text-style my-3">
                              Characteristic
                            </p>
                            <p
                              class="mb-5"
                              style="word-break: break-all"
                              v-html="ProductData.htmleProDesc"
                            ></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button
                    type="button"
                    class="PcDevice btn btn-lg btn-secondary"
                    data-dismiss="modal"
                  >
                    關閉
                  </button>
                  <button
                    type="button"
                    class="MbDevice btn btn-sm btn-lg btn-secondary"
                    data-dismiss="modal"
                  >
                    關閉
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Modal 新聞稿彈跳模組-->
          <div
            class="modal fade"
            id="openEventNoModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="ModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <div class="PcDevice">
                    <div class="modal-title h3" id="ModalLabel">
                      <i class="fas fa-sort mr-1"></i> 活動排序
                    </div>
                  </div>
                  <div class="MbDevice">
                    <div class="modal-title h5" id="ModalLabel">
                      <i class="fas fa-sort mr-1"></i>
                      活動排序
                    </div>
                  </div>
                  <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    @click.prevent="CloseEventNoModal"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <div class="modal-body my-2">
                  <div class="mb-3">
                    <div>
                      *請
                      <span style="text-decoration: underline"
                        >手動拖拉活動名稱</span
                      >
                      以調整活動排序。
                    </div>
                    <div>*調整活動排序後，請按下「儲存」按鈕才算完成修改。</div>
                  </div>

                  <hr />

                  <div class="Pro_draggable mb-1 font-weight-bold">
                    <div class="index-item mb-1">序號</div>
                    <div class="mb-1" style="padding: 0 5px">活動名稱</div>
                  </div>
                  <div class="Pro_draggable">
                    <div>
                      <div
                        v-for="(item, index) in EventFilterList"
                        :key="item.BoothEventID"
                        class="index-item"
                      >
                        {{ index + 1 }}.
                      </div>
                    </div>
                    <div style="flex-grow: 1">
                      <draggable v-model="EventFilterList" @end="onEnd">
                        <div
                          v-for="(item, index) in EventFilterList"
                          :key="item.BoothEventID"
                          class="event-item shadow-sm"
                        >
                          {{ item.BoothEventName }}
                        </div>
                      </draggable>
                    </div>
                  </div>
                </div>

                <div class="modal-footer">
                  <div class="d-flex">
                    <div class="mr-2">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click.prevent="SaveEventSort"
                      >
                        儲存
                      </button>
                    </div>
                    <div>
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click.prevent="CloseEventNoModal"
                      >
                        關閉
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import Dashboard from "@/components/Dashboard_en.vue";
import $ from "jquery";
import axios from "axios";
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
    Dashboard,
  },
  metaInfo() {
    return {
      title: "Booth Events - Chan Chao Exhibitor's Online Service System",
    };
  },

  data() {
    return {
      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      EventAmount: 3,
      ProductData: {},
      companyName: "",
      ecompanyName: "",
      SelectCat: "",
      BoothNo: "",

      currentPage: 2,
      totalPage: "",
      totalNo: "",
      ProductRawData: [],
      EventList: [],
      totaltenPageNum: 0,
      tenPageNum: 0,
      showpage: [],
      lang: "tw",
      logoImg: "",

      //判斷各頁狀態儀表版值
      OnlineExpolayoutStatus: "",
      PressReleaseStatus: "",
      VideoStatus: "",
      ProductStatus: "",
      BasicinformationStatus: "",

      //判斷儀表板是否有線上展
      openOnlineExpo: "",
      showOnlineStatus: false,

      getArch: "",

      messages: [],

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",

      EventFilterList: [],
      LocalExh: true,
      BoothEventAmount_vip: "",
      BoothEventAmount: "",
    };
  },
  methods: {
    formatEventDateTime(dateTimeStr) {
      let [startStr, endTime] = dateTimeStr.split("~").map((s) => s.trim());
      let date = new Date(startStr.replace(/-/g, "/"));
      let days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      let weekday = days[date.getDay()];
      let dateOnly = startStr.split(" ")[0];
      let startTime = startStr.split(" ")[1];

      return `${dateOnly}(${weekday}) ${startTime} ~ ${endTime}`;
    },
    SaveEventSort() {
      $("#openEventNoModal").modal("hide");
      // window.location.reload()

      const vm = this;

      let info = {
        BoothEventSort: vm.EventFilterList,
        CSRF: vm.CSRF_Token,
        RegNo: vm.RegNo,
      };

      const url = `/apiExhibitors/BoothEvent/Sort`;
      axios.post(url, info).then(function (response) {
        console.log(response);
        if (response.data.Code == 200) {
          alert("You have successfully updated the event order！");

          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
        } else if (response.data.Code == 404) {
          alert("No data found.");
        } else if (response.data.Code == 252) {
          alert("CSRF verification failed.");
        } else {
          alert("The system is busy, please try again later.");
        }
      });
    },

    openEventNo() {
      const vm = this;

      //取得活動列表
      let url = `https://www.chanchao.com.tw/apiExhibitors/BoothEvent/${vm.RegNo}?mode=&Page=`;

      axios.get(url).then(function (response) {
        if (response.data.Code == 200) {
          let GetEventFilterList = response.data.Data;

          vm.EventFilterList = GetEventFilterList.map((item) => {
            return {
              BoothEventName: item.BoothEventName,
              BoothEventID: item.BoothEventID,
            };
          });

          $("#openEventNoModal").modal("show");
        } else if (response.data.Code == 404) {
        }
      });
    },

    CloseEventNoModal() {
      const vm = this;
      $("#openEventNoModal").on("hide.bs.modal", function () {
        vm.ModalData = [];
      });
      $("#openEventNoModal").modal("hide");
    },

    onEnd(event) {},
    updateMessage(message, status) {
      const timestamp = Math.floor(new Date() / 1000);
      this.messages.push({
        message,
        status,
        timestamp,
      });
      this.removeMessageWithTiming(timestamp);
    },
    removeMessage(num) {
      this.messages.splice(num, 1);
    },
    removeMessageWithTiming(timestamp) {
      const vm = this;
      setTimeout(() => {
        vm.messages.forEach((item, i) => {
          if (item.timestamp === timestamp) {
            vm.messages.splice(i, 1);
          }
        });
      }, 1500);
    },

    getPage(page) {
      const vm = this;

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}&Page=${page}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}&Page=${page}`;
      }
    },

    nextPage() {
      const vm = this;
      let nextP = Number(vm.currentPage) + 1;

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}&Page=${nextP}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}&Page=${nextP}`;
      }
    },

    lastPage() {
      const vm = this;
      let lastP = Number(vm.currentPage) - 1;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}&Page=${lastP}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}&Page=${lastP}`;
      }
    },

    nexttenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum + 1;
      vm.showpage = vm.inquiryRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}&Page=${vm.currentPage}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}&Page=${vm.currentPage}`;
      }
    },

    returntenPage() {
      const vm = this;
      vm.tenPageNum = vm.tenPageNum - 1;
      vm.showpage = vm.inquiryRawData[vm.tenPageNum];
      vm.currentPage = vm.showpage[0];

      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}&Page=${vm.currentPage}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}&Page=${vm.currentPage}`;
      }
    },

    EventModal(id) {
      const vm = this;

      let url = `/apiExhibitors/Product/${vm.RegNo}/${id}`;
      axios.get(url).then(function (response) {
        // console.log(response.data)
        vm.ProductData = response.data.Data;
      });

      if (vm.lang == "tw") {
        $('#openModal a[href="#nav-home"]').tab("show");
        $("#openModal").modal("show");
      } else {
        $('#openModal a[href="#nav-profile"]').tab("show");
        $("#openModal").modal("show");
      }
    },

    toEventAdd() {
      const vm = this;
      if (vm.EventAmount > vm.totalNo) {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/BootheventAdd?no=${vm.RegNo}`;
      } else {
        alert(
          "You have no remaining event quota. To publish more events, please check the upgrade options in the value-added service plan."
        );
      }
    },

    toEditEvent(id) {
      const vm = this;
      // console.log($(window).scrollTop())

      if (vm.currentPage == 1) {
        sessionStorage.setItem("scrollHeight", $(window).scrollTop());
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/BootheventEdit?no=${vm.RegNo}&id=${id}`;
      } else {
        sessionStorage.setItem("scrollHeight", $(window).scrollTop());
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/BootheventEdit?no=${vm.RegNo}&id=${id}`;
      }
    },

    delEvent(id) {
      const vm = this;

      if (confirm("Delete this Booth Event? ")) {
        const info = {
          CSRF: vm.CSRF_Token,
          RegNo: vm.RegNo,
          BoothEventID: id,
        };

        const url = `/apiExhibitors/BoothEvent/Delete`;

        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            vm.updateMessage(`Event successfully deleted !`, "warning");

            vm.getEvent("Del");
          } else if (response.data.Code == 251) {
            alert("System is busy, please try again later.");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 500) {
            alert("System is busy, please try again later.");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
          }
        });
      } else {
        return false;
      }
    },

    switchButtom(BoothID, IsShow) {
      const vm = this;

      if (!IsShow) {
        let info = {
          BoothEventID: BoothID,
          CSRF: vm.CSRF_Token,
          RegNo: vm.RegNo,
          IsShow: true,
        };

        const url = `/apiExhibitors/BoothEvent/State`;
        axios.post(url, info).then(function (response) {
          if (response.data.Code == 200) {
            vm.updateMessage("Changed to visible status", "warning");

            vm.getEvent("Switch");
          } else if (response.data.Code == 253) {
            alert("Invalid event ID！");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else {
            alert("The system is busy, please try again later！");
          }
        });
      } else if (IsShow) {
        const info2 = {
          BoothEventID: BoothID,
          CSRF: vm.CSRF_Token,
          RegNo: vm.RegNo,
          IsShow: false,
        };

        const url2 = `/apiExhibitors/BoothEvent/State`;
        axios.post(url2, info2).then(function (response) {
          if (response.data.Code == 200) {
            vm.updateMessage("Changed to hidden status", "warning");

            vm.getEvent("Switch");
          } else if (response.data.Code == 401) {
            alert("Format error！");
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else {
            alert("The system is busy, please try again later！");
          }
        });
      }
    },

    getEvent(Stats) {
      const vm = this;

      //取得活動列表
      let url = `https://www.chanchao.com.tw/apiExhibitors/BoothEvent/${vm.RegNo}?mode=&Page=${vm.currentPage}}&Lang=tw`;

      axios.get(url).then(function (response) {
        if (response.data.Code == 200) {
          vm.totalNo = response.data.datatotal;

          vm.EventList = response.data.Data;
          vm.totalPage = response.data.pagetotal;

          if (Stats == "Del") {
            if (vm.currentPage <= vm.totalPage) {
            } else {
              if (vm.lang == "tw") {
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}`;
              } else {
                document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
              }
            }
          }
        } else if (response.data.Code == 404) {
          window.location.reload();
        }
      });
    },
  },

  created() {
    const vm = this;

    setTimeout(() => {
      let getscrollHeight = sessionStorage.getItem("scrollHeight");
      if (getscrollHeight) {
        window.scrollTo(0, getscrollHeight);
        sessionStorage.removeItem("scrollHeight");
      }
    }, 200);

    //取得語系

    $(() => {
      $("#SliderTop").click(() => {
        $("html,body").animate({ scrollTop: 0 }, "slow");
        return false;
      });

      $(window)
        .scroll(function () {
          if ($(this).scrollTop() > 300) {
            $("#SliderTop").fadeIn(222);
          } else {
            $("#SliderTop").stop().fadeOut(222);
          }
        })
        .scroll();
    });

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;

    //取得RegNo
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];

    let hasPagenum = new URL(currentUrl);
    vm.currentPage = hasPagenum.searchParams.get("Page");

    if (!vm.currentPage) {
      vm.currentPage = 1;
    }

    //取得是否開啟線上展權限
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        // console.log(response.data)

        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;

        vm.logoImg = response.data.Data.ExhLogo;
        vm.openOnlineExpo = response.data.Data.OnlineExpo_Archived;
        let ExpoLocation = response.data.Data.ExpoLocation;

        vm.BoothEventAmount_vip = response.data.Data.Exh_BoothEventAmount_vip;
        vm.BoothEventAmount = response.data.Data.Exh_BoothEventAmount;

        if (ExpoLocation === "T" || ExpoLocation === null) {
          vm.LocalExh = true;
        } else {
          vm.LocalExh = false;
        }

        // 取得活動額度
        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`
          )
          .then((response) => {
            vm.companyName = response.data.Data.Company;
            vm.ecompanyName = response.data.Data.eCompany;
            vm.BoothNo = response.data.Data.BoothNo;

            if (response.data.Data.Vip == 5 || response.data.Data.Vip == 3) {
              vm.EventAmount = vm.BoothEventAmount_vip;
            } else {
              vm.EventAmount = vm.BoothEventAmount;
            }
          });
      });

    //取得活動列表
    let url = `https://www.chanchao.com.tw/apiExhibitors/BoothEvent/${vm.RegNo}?mode=list&Page=${vm.currentPage}&Lang=tw`;

    axios.get(url).then(function (response) {
      if (response.data.Code == 200) {
        vm.totalNo = response.data.datatotal;

        if (response.data.pagetotal > 0) {
          vm.EventList = response.data.Data;

          vm.totalPage = response.data.pagetotal;

          if (vm.currentPage <= vm.totalPage) {
          } else {
            if (vm.lang == "tw") {
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}`;
            } else {
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
            }
          }

          for (let i = 0; i < vm.totalPage; i++) {
            if (i % 10 === 0) {
              vm.ProductRawData.push([]);
            }

            const page = parseInt(i / 10); //取parseInt整數
            vm.ProductRawData[page].push(i + 1);
          }

          //totaltenPageNum 取得共有幾筆十頁
          vm.totaltenPageNum = vm.ProductRawData.length;
          //從取得的筆數後，tenNum 計算出現第幾個十頁數

          let anaNowPage = vm.currentPage - 1; //判定第幾頁(十頁)，頁數減一避免進位

          vm.tenPageNum = parseInt(anaNowPage / 10);
          vm.showpage = vm.ProductRawData[vm.tenPageNum];
        } else {
          if (vm.currentPage > 1) {
            if (vm.lang == "tw") {
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/Boothevent?no=${vm.RegNo}`;
            } else {
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/Boothevent?no=${vm.RegNo}`;
            }
          }
        }
      } else if (response.data.Code == 404) {
        vm.totalNo = 0;
        vm.totalPage = 0;
      }
    });
  },
};
</script>

<style lang="scss">
.NumberStyle {
  width: 30px;
  height: 30px;
  border-radius: 999em;
  background-color: #e6e5e5;
  font-size: 14px;
  font-weight: 700;
}

.card-footer {
  padding: 0.1rem 0.2rem;
  background-color: rgb(255 255 255 / 3%);
  border-top: 1px solid rgba(0, 0, 0, 0.125);
}

.uncomplete {
  background-image: url("../../../assets/images/tickGray.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.complete {
  background-image: url("../../../assets/images/tick.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.btn-outline-primary:hover {
  color: #1d49e7;
  /* background-color: #007bff; */
  /* border-color: #007bff; */
  background-color: #007bff00;
}

.message-alert {
  position: fixed;
  max-width: 75%;
  top: 100px;
  right: 20px;
  z-index: 1100;
}

.animate__animated {
  --animate-duration: 0.5s;
}

.alertM {
  padding: 15px 20px;
  font-size: 14px;
  border-radius: 5px;
  margin-top: 7px;
}

.Pro_draggable {
  display: flex;
  align-items: center;
  width: 100%; /* 確保容器不超出螢幕寬度 */
  flex-wrap: nowrap; /* 禁止換行，讓序號和名稱保持在同一行 */
}
.index-item {
  width: 34px; /* 固定寬度讓序號不會變形 */
  text-align: center;
  margin-right: 10px;
  border: 1px solid #ffffff; /* 添加邊框 */
  margin-bottom: 7px;
}

.event-item {
  white-space: nowrap; /* 防止名稱換行 */
  overflow: hidden;
  text-overflow: ellipsis; /* 如果名稱太長，顯示省略號 */
  cursor: move;
  flex-grow: 1; /* 讓名稱區域自動佔滿剩餘空間 */
  max-width: 100%; /* 保證名稱不會超過父容器 */
  box-sizing: border-box; /* 讓 padding 和 border 包含在寬度內 */
  border: 1px solid #0046ff52; /* 添加邊框 */
  background-color: #dfe9f663;
  padding: 0px 5px;
  margin-bottom: 7px;
}

.modal-body {
  overflow-y: scroll;
  max-height: 80vh;
}

.modal-header {
  background-color: #eeecec;
}
</style>
